// extracted by mini-css-extract-plugin
module.exports = {"active":"Part_active__jpNdB","part":"Part_part__DuF2p"};